<fa-icon [icon]="['far', 'info-circle']" [pTooltip]="text" size="sm" class="text-muted" [ngClass]="class"></fa-icon>
